import {twoByTwoLayout, TwoByTwoLayout} from "./two-by-two/TwoByTwoLayoutComponent";
import {singleLayout, SingleLayout} from "./single/SingleLayoutComponent";
import {twoColumnLayout, TwoColumnLayout} from "./two-column/TwoColumnLayoutComponent";
import {oneLeftTwoRight, OneLeftTwoRight} from "./one-left-two-right/OneLeftTwoRightLayoutComponent";
import {twoLeftOneRight, TwoLeftOneRight} from "./two-teft-one-right/TwoLeftOneRightLayoutComponent";
import {threeByTwoLayout, ThreeByTwoLayout} from "./three-by-two/ThreeByTwoLayoutComponent";
import {oneTopTwoBottom, OneTopTwoBottomLayout} from "./one-top-two-bottom/OneTopTwoBottomLayoutComponent";
import {twoTopOneBottom, TwoTopOneBottomLayout} from "./two-top-one-bottom/TwoTopOneBottomLayoutComponent";

export default function() {
    return angular.module("tfApp.dashboard.oms.components.layout", [])
                  .component(SingleLayout, singleLayout())
                  .component(TwoColumnLayout, twoColumnLayout())
                  .component(OneLeftTwoRight, oneLeftTwoRight())
                  .component(TwoLeftOneRight, twoLeftOneRight())
                  .component(TwoByTwoLayout, twoByTwoLayout())
                  .component(ThreeByTwoLayout, threeByTwoLayout())
                  .component(OneTopTwoBottomLayout, oneTopTwoBottom())
                  .component(TwoTopOneBottomLayout, twoTopOneBottom())
                  .name;
}
